import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://duocapital.onrender.com";
export const API = `${BACKEND.replace(/\/+$/,'')}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("duo_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// AI Bot subscription tiers — no ROI shown; they unlock real investing + set loan caps
export const BOT_TIER_META = {
  starter:  { name: "Starter",      amount: 1000,  color: "#C0C0C0", glow: "tier-glow-starter",  badge: null },
  growth:   { name: "Growth",       amount: 5000,  color: "#3B82F6", glow: "tier-glow-growth",   badge: "MOST POPULAR" },
  premium:  { name: "Premium",      amount: 8000,  color: "#8B5CF6", glow: "tier-glow-premium",  badge: null },
  elite:    { name: "Elite",        amount: 10000, color: "#D4AF37", glow: "tier-glow-elite",    badge: null },
  platinum: { name: "Platinum VIP", amount: 25000, color: "#FFFFFF", glow: "tier-glow-platinum", badge: "EXCLUSIVE" },
};

export const INVESTMENT_TIER_META = {
  starter:    { name: "Starter",      amount: 1000,  max: 4999,  roi: 15, color: "#C0C0C0", glow: "tier-glow-starter",  badge: null },
  growth:     { name: "Growth",       amount: 5000,  max: 9999,  roi: 22, color: "#3B82F6", glow: "tier-glow-growth",   badge: "MOST POPULAR" },
  elite:      { name: "Elite",        amount: 10000, max: 14999, roi: 40, color: "#D4AF37", glow: "tier-glow-elite",    badge: null },
  elite_plus: { name: "Elite Plus",   amount: 15000, max: 19999, roi: 45, color: "#D4AF37", glow: "tier-glow-elite",    badge: null },
  elite_pro:  { name: "Elite Pro",    amount: 20000, max: 24999, roi: 50, color: "#D4AF37", glow: "tier-glow-elite",    badge: null },
  platinum:   { name: "Platinum VIP", amount: 25000, max: null,  roi: 55, color: "#FFFFFF", glow: "tier-glow-platinum", badge: "EXCLUSIVE" },
};
// Backward-compat: some components import TIER_META directly (e.g. for bot tier display)
export const TIER_META = BOT_TIER_META;

export const BOT_TIER_KEYS = ["starter", "growth", "premium", "elite", "platinum"];
export const INVESTMENT_TIER_KEYS = ["starter", "growth", "elite", "elite_plus", "elite_pro", "platinum"];
export const TIER_KEYS = BOT_TIER_KEYS;

export const LOAN_CAPS = {
  starter: 2000,
  growth: 10000,
  premium: 16000,
  elite: 20000,
  platinum: 50000,
};

export function getLoanCap(tier) {
  return LOAN_CAPS[tier] || 0;
}